import { useCallback } from "react";
import { ConjugationProgress } from "../utils/conjugationProgressStorage";
import { useDeviceProgress } from "./useDeviceProgress";

export function useConjugationProgress() {
    const { data: progress, update, syncStatus } = useDeviceProgress<ConjugationProgress>("conjugationProgress");
    const setLearned = useCallback((key: string, learned: boolean) => {
        void update(learned ? { kind: "set", key, value: "learned" } : { kind: "remove", key });
    }, [update]);
    return { progress, setLearned, syncStatus };
}
